import React, { memo, useContext, useCallback } from 'react';
import { View, FlatList } from 'react-native';
import { isAfter, startOfQuarter, setYear, setQuarter, parseISO, } from 'date-fns';
import Spacer from 'design-system/Spacer';
import { rem } from 'design-system/values';
import { Button } from 'design-system/Button';
import createStyleSheets from 'utils/createStyleSheets';
import useStyles from 'hooks/useStyles';
import { DateFilterContext } from './context';
import SelectorWithButtons from '../analyticsFilter/SelectorWithButtons';
import { quartersArr, filterStartYear } from './constants';
const QuarterlyContent = () => {
    const styles = useStyles(styleSet);
    const { currentYear, selectedYear, selectedQuarter, setSelectedYear, setSelectedQuarter, todayDateStr, } = useContext(DateFilterContext);
    const changeYear = useCallback((decrease) => () => {
        if (decrease) {
            if (selectedYear > filterStartYear) {
                setSelectedYear(selectedYear - 1);
            }
            return;
        }
        if (selectedYear < currentYear) {
            setSelectedYear(selectedYear + 1);
        }
    }, [currentYear, selectedYear, setSelectedYear]);
    return (<View style={styles.container}>
      <Spacer h={16}/>
      <SelectorWithButtons title={selectedYear} onForward={changeYear(false)} onBackward={changeYear(true)} disableForward={selectedYear === currentYear} disableBackward={selectedYear === filterStartYear}/>
      <FlatList numColumns={4} data={quartersArr} scrollEnabled={false} contentContainerStyle={styles.contentContainerStyles} columnWrapperStyle={styles.columnWrapperStyle} renderItem={({ item, index }) => (<View style={styles.eachButtonContainer}>
            <Button flex square title={item} disabled={selectedYear === currentYear &&
                isAfter(startOfQuarter(setYear(setQuarter(new Date(), index + 1), selectedYear)), parseISO(todayDateStr))} containerStyle={styles.buttonStyles} onPress={() => setSelectedQuarter(index + 1)} {...(selectedQuarter === index + 1
            ? { brandTextBorder: true }
            : { gray: true })}/>
          </View>)}/>
    </View>);
};
export default memo(QuarterlyContent);
const styleSet = createStyleSheets((colors) => ({
    container: {
        paddingTop: rem(8),
        backgroundColor: colors.background.light,
    },
    columnWrapperStyle: {
        flex: 1,
    },
    eachButtonContainer: {
        flex: 1,
        margin: rem(8),
        height: rem(45),
    },
    contentContainerStyles: {
        padding: rem(8),
    },
    buttonStyles: {
        height: rem(42),
    },
}));
